import { createFileRoute } from '@tanstack/react-router'
import { WorkItemPage } from '@/features/workflows/ui/work-item-page'

export const Route = createFileRoute('/_authenticated/tasks/$workflow-id/$work-item-id')({
	component: WorkItemPageRoute,
})

function WorkItemPageRoute() {
	const params = Route.useParams()
	return <WorkItemPage workflowId={params['workflow-id']} workItemId={params['work-item-id']} />
}
